import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'SpacePublisherPage.PublisherNotifications.Title',
    defaultMessage: 'Publisher Notification Manager'
  }
})
